// extracted by mini-css-extract-plugin
export default {"firstMenuItems":"firstMenuItems---nx1VM"};